module.exports = __webpack_public_path__ + "static/media/spa-banner.e6721fe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/spa-banner.png
// module id = 198
// module chunks = 6